import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = 'admin_token';
const ADMIN_USER_KEY = 'admin_user';

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터: /admin/* 요청은 admin_token, /app/* 요청은 member_token 자동 부착.
apiClient.interceptors.request.use((config) => {
  const url = config?.url || '';
  // Absolute URL 이거나 baseURL 사용 상관 없이 path 기준으로 판단
  const isAdminApi = url.includes('/admin/') || url.startsWith('/admin');
  const isAdminAuthLogin = url.includes('/admin/auth/login');
  if (isAdminApi && !isAdminAuthLogin) {
    try {
      const token = localStorage.getItem(ADMIN_TOKEN_KEY);
      if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (_) {}
  }
  return config;
});

// 응답 인터셉터: 401 발생 시 해당 영역(회원/관리자)의 로컬 인증 정리 후 로그인 화면 이동.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const path = window.location.pathname || '';

    // 회원 앱 401 처리 (기존 동작 유지)
    const isMemberApp = path.startsWith('/app') || path === '/app';
    const isMemberApi = url.includes('/app/');
    if (status === 401 && isMemberApp && isMemberApi && path !== '/app/login') {
      try {
        localStorage.removeItem('member_token');
        localStorage.removeItem('member');
        localStorage.removeItem('is_default_pin');
        localStorage.removeItem('pin_warning_shown');
      } catch (_) {}
      window.location.replace('/app/login');
      return Promise.reject(error);
    }

    // 관리자 401 처리: /admin/* API 실패 시 CRM 로그인 화면으로 이동
    const isAdminApi = url.includes('/admin/');
    const isAdminPage = path.startsWith('/admin');
    if (
      status === 401 &&
      isAdminApi &&
      isAdminPage &&
      path !== '/admin/login' &&
      !url.includes('/admin/auth/login')
    ) {
      try {
        localStorage.removeItem(ADMIN_TOKEN_KEY);
        localStorage.removeItem(ADMIN_USER_KEY);
      } catch (_) {}
      window.location.replace('/admin/login');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
